import { connect } from 'react-redux';

import {
  getClientDetails,
  getClientShortList,
} from '../ClientsNew/clientsActions';
import Invoice from './Invoice';
// Actions
import {
  createInvoiceUpdateSendLog,
  deleteInvoice,
  getInvoiceList,
  recordPaymentInvoice,
  sendInvoiceEmail,
} from './invoiceActions';

// Store props to map with current state
const mapStateToProps = state => ({
  selectedOrganization: state.organization.selectedOrganization,
  clientShortList: state.client.clientShortList,
  clientDetails: state.client.clientDetails,
  profileData: state.profile.profileData,

  isLoading: state.invoice.isLoading,
  sendMailLoading: state.invoice.sendMailLoading,
  recordPaymentLoading: state.invoice.recordPaymentLoading,
  paymentDetailsLoading: state.invoice.paymentDetailsLoading,
  deleteInvoiceLoading: state.invoice.deleteInvoiceLoading,
  noData: state.invoice.noData,
  invoiceList: state.invoice.invoiceList,
  updateInvoiceSendLog: state.invoice.updateInvoiceSendLog,
  sendInvoiceEmailInfo: state.invoice.sendInvoiceEmailInfo,
  recordPaymentInfo: state.invoice.recordPaymentInfo,
  deletedInvoiceCallback: state.invoice.deletedInvoiceCallback,
  filters: state.filterReducer.filters,

  // pagination
  totalInvoicesCount: state.invoice.totalInvoicesCount,
  invoicePageSize: state.invoice.invoicePageSize,
  reloadInvoiceList: state.invoice.reloadInvoiceList,
});

// Actions prop to dispatch
const mapDispatchToProps = dispatch => ({
  getInvoiceList: details => dispatch(getInvoiceList({ ...details })),
  recordPaymentInvoice: details =>
    dispatch(recordPaymentInvoice({ ...details })),
  createInvoiceUpdateSendLog: details =>
    dispatch(createInvoiceUpdateSendLog({ ...details })),
  sendInvoiceEmail: details => dispatch(sendInvoiceEmail({ ...details })),
  deleteInvoice: details => dispatch(deleteInvoice({ ...details })),

  getClientShortList: details => dispatch(getClientShortList({ ...details })),
  getClientDetails: details => dispatch(getClientDetails({ ...details })),
});

// connect states and dispatchers with components
export default connect(mapStateToProps, mapDispatchToProps)(Invoice);
